$.plugins.panel_desktop = {
	__init: function () {
		this.addClass('desktop');
		this.type = 'desktop';
		
		this.dimensions = {
			width: 1700,
			height: 174,
			font: 36,
			screen_width: 1920,
			screen_height: 1080,
		};
		
		/* Meters */
		{
			this.credits = $.div().addClass('credits').apply('meter', { label: 'Balance', value: 0 }).appendTo(this);
			this.registerCash(this.credits, true);
			
			this.win = $.div().addClass('win').apply('meter', { label: 'Win', value: 0, animate: true }).appendTo(this);
			this.registerCash(this.win, true);
			
			this.win.label.appendTo(this.win);
		}
		
		/* Play Button */
		{
			this.play = $.div('play').apply('button', {  });
			this.addItem(this.play, 'middle');
			
			this.play.on('click', function () {
				if (this.hasClass('hide') || this.hasClass('disabled')) {
					return;
				}

				if (game.panel.state && game.panel.state === 'lock') {
					return;
				}
				
				if (game.panel.disabled) {
					this.emit('slam');
					
					return;
				}
				
				this.emit('play');
				game.sounds.play([ 'buttons', 'spin' ]);
			});
			
			$(document).on('keydown', function (e) {
				if (e.keyCode === 32) {
					game.panel.play.trigger('click');
				}
			});
		}
		
		/* Help */
		{
			this.buildHelp = function (count) {
				this.help = [];
				this.help.slug = 'help';
				
				for (var i = 1; i <= count; i++) {
					this.help.push($.div().addClass('help help-' + i));
				}
			};
		}
		
		/* Menu Button */
		{
			this.info = $.div().apply('button', { label: 'Menu' });
			this.addItem(this.info, 'left far');
			this.info.on('click', function (e) {
				if (e.target === this.el || e.target === this.label.el) {
					game.sounds.play([ 'buttons', 'menu' ]);
				}
			});
			
			var menu = this.info.addMenu({ transition: 'up' });
			this.registerMenu(menu);
			
			this.info.lobby = $.div().apply('button', { label: 'Return To Lobby' });
			this.info.menu.addItem(this.info.lobby);
			this.info.lobby.on('click', function () {
				if (game.panel.disabled) {
					return;
				}
				
				game.sounds.play([ 'buttons', 'lobby' ]);
				game.panel.trigger('lobby');
			});
			
			this.info.sound = $.div().apply('toggle', { label: 'Sound' });
			this.info.menu.addItem(this.info.sound);
			this.info.sound.on('update', function () {
				game.sounds.volume(this.is() ? 1 : 0);
				
				if (this.is()) {
					game.sounds.play([ 'buttons', 'sound' ]);
				}
			});
			
			this.info.turbo = $.div().apply('toggle', { label: 'Turbo', value: false });
			this.info.menu.addItem(this.info.turbo);
			this.info.turbo.on('update', function () {
				game.setTurbo(this.is());
				
				game.sounds.play([ 'buttons', 'turbo' ]);
			});
			
			this.info.recall = $.div().apply('button', { label: 'Game Recall' });
			this.info.menu.addItem(this.info.recall);
			this.info.recall.on('click', function () {
				if (game.panel.disabled) {
					return;
				}
				
				game.sounds.play([ 'buttons', 'recall' ]);
				game.panel.trigger('recall');
				menu.hide();
			});
			
			this.info.help = $.div().apply('button', { label: 'Help/Pay' });
			this.info.menu.addItem(this.info.help);
			this.info.help.on('click', function () {
				game.sounds.play([ 'buttons', 'help' ]);
				game.panel.dialog.show(game.panel.help);
				menu.hide();
			});
		}
	},
	
	addItem: function (item, position) {
		item.addClass(position);
		item.appendTo(this);
		
		return item;
	},
	
	hide: function (value) {
		if (!value) {
			return;
		}
		
		this.addClass('hide');
		
		this.bigwin.stop(true);
		
		if (this.info.menu.hasClass('show')) {
			this.info.menu.toggle();
		}
		
		if (this.auto && this.auto.menu.hasClass('show')) {
			this.auto.menu.toggle();
		}
	},
	
	show: function (value) {
		if (!value) {
			return;
		}
		
		this.removeClass('hide');
	},
};



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/js/core-desktop.js
 **/